import { connect } from 'react-redux'
import { withHandlers, compose } from 'recompose'
import { googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getGTMProductData } from '../../helpers'
import Product from './Product'
import { HOME_PAGE_SOURCE } from 'constant'

const withProductClickHandler = withHandlers({
  handleProductClick: ({
    index: position,
    title: label,
    price,
    skuId,
    brandName,
    skuDisplayName,
    productDisplayName,
    googleAnalyticProductClicks
  }) => () => {
    googleAnalyticProductClicks({
      data: getGTMProductData({
        skuId,
        price,
        label,
        position,
        brandName,
        skuDisplayName,
        productDisplayName
      }),
      ...HOME_PAGE_SOURCE
    })
  }
})

export default compose(
  connect(null, { googleAnalyticProductClicks }),
  withProductClickHandler
)(Product)
